import { DATE_DATABASE_FORMAT } from "@/common/constants";
import { getDateInterval } from "@/common/functions";
import { addSeconds, format } from "date-fns";
export const collectionToLeaderboardParticipant = (result) => {
    return result.map((participant) => objectToLeaderboardParticipant(participant));
};
const objectToLeaderboardParticipant = (participant) => {
    return {
        firstName: participant.fname,
        lastName: participant.lname,
        teamName: participant.tname,
        image: participant.img,
        distance: +participant.dist,
        countryCode: participant.flag && participant.flag !== ""
            ? participant.flag
            : "ZZ",
        rank: +participant.rank,
        id: +participant.id,
        type: participant.type,
        isCurrentUser: +participant.is_current === 1 ? true : false,
        isFirst: +participant?.is_first === 1 ? true : false,
        isLast: +participant?.is_last === 1 ? true : false,
        completionPct: +participant.pct,
        exerciseTypes: participant.exercise_distances?.map((exercise) => ({
            alias: exercise.exercise_type,
            distance: +exercise.distance,
        })) ?? [],
        completedTime: participant.secs
            ? getLeaderboardCompletedDateFormat(+participant.secs)
            : "",
    };
};
export const objectToLeaderboardLookup = (user) => {
    return {
        id: +user.item.id,
        distance: +user.item.dist,
        count: +user.count,
        rank: +user.item.rank,
        avatarImage: user.item.img,
        countryCode: user.item.flag !== "" ? user.item.flag : "ZZ",
        type: user.item.type,
        completionPct: user.item.pct,
        firstName: user.item.fname,
        lastName: user.item.lname,
        completedTime: user.item.secs
            ? getLeaderboardCompletedDateFormat(+user.item.secs)
            : "",
        teamName: user.item.tname ?? "",
        distanceUnit: user.distance_unit,
        exerciseTypes: user.exercise_distances.map((type) => ({
            alias: type.exercise_type,
            distance: type.distance,
        })),
        teamMembers: !user.team_members
            ? []
            : user.team_members.map((member) => {
                return {
                    firstName: member.fname,
                    lastName: member.lname,
                    image: member.img,
                    countryCode: member.flag && member.flag !== ""
                        ? member.flag
                        : "ZZ",
                    distance: member.dist,
                    id: member.id,
                    isCurrentUser: member.is_current,
                    completionPct: member.pct,
                    type: member.type,
                    rank: member.rank,
                    isFirst: member.is_first ? true : false,
                    isLast: member.is_last ? true : false,
                    exerciseTypes: member.exercise_distances.map((type) => ({
                        alias: type.exercise_type,
                        distance: type.distance,
                    })),
                };
            }),
    };
};
const getLeaderboardCompletedDateFormat = (seconds) => {
    const minuteInSeconds = 60;
    if (seconds < minuteInSeconds) {
        return `${seconds}secs`;
    }
    return getDateInterval(format(new Date(0), DATE_DATABASE_FORMAT), format(addSeconds(new Date(0), seconds), DATE_DATABASE_FORMAT));
};
